import { render, staticRenderFns } from "./GiftshopPricegroups.vue?vue&type=template&id=3145fcec&"
import script from "./GiftshopPricegroups.vue?vue&type=script&lang=ts&"
export * from "./GiftshopPricegroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports